(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bomba-shop-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Staggered entrance animation for product cards (skipped under reduced motion)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cards = document.querySelectorAll('.bomba-product-card');
    if (cards.length > 0 && typeof gsap !== 'undefined' && !prefersReducedMotion) {
      gsap.set(cards, { opacity: 0, y: 24 });
      gsap.to(cards, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.06,
        ease: "power3.out",
        clearProps: "transform"
      });
    }

    // Filter form auto-submit
    const filterForm = document.getElementById('bomba-plp-filter-form');
    if (filterForm) {
      let debounceTimer;
      // Build the URL from the sidebar's own inputs (+ the sort select) only —
      // never filterForm.submit(). The drawer renders a SECOND copy of every
      // filter input that also references this form, so a native submit would
      // serialize those duplicates and re-add a filter you just unchecked here
      // (you couldn't toggle a filter off — only "Wis filters" worked).
      const baseUrl = filterForm.getAttribute('action') || window.location.pathname;
      const submit = () => {
        const params = new URLSearchParams();
        document.querySelectorAll('[data-filter-input]').forEach((el) => {
          if (el.closest('.bomba-drawer')) return; // skip the drawer's duplicate inputs
          if (el.type === 'checkbox') {
            if (el.checked) params.append(el.name, el.value);
          } else if (el.value !== '' && el.value != null) {
            params.set(el.name, el.value);
          }
        });
        const qs = params.toString();
        window.location.href = qs ? baseUrl + '?' + qs : baseUrl;
      };
      // Pressing Enter in a price field triggers the form's implicit submission.
      // Catch it so it routes through the scoped builder instead of a native GET
      // (which would send empty params + the drawer's duplicate inputs).
      filterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        submit();
      });
      document.querySelectorAll('[data-filter-input]').forEach((input) => {
        // Drawer inputs are batched and applied via the drawer's Apply button;
        // only the desktop sidebar + sort auto-submit on change.
        if (input.closest('.bomba-drawer')) return;
        const isText =
          input.tagName === 'INPUT' && (input.type === 'number' || input.type === 'text');
        input.addEventListener('change', submit);
        if (isText) {
          input.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(submit, 600);
          });
        }
      });
    }

    // Collections nav: two-layer accordion (mirrors the header menu).
    // Sibling-based toggle so it works in both the sidebar and the drawer.
    document.querySelectorAll('[data-filter-acc]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = btn.nextElementSibling;
        const open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (sub) sub.classList.toggle('is-open', open);
      });
    });

    // PLP sidebar scroll indicator: native bar hidden on the inner scroller; a
    // copper thumb reflects it — height = visible fraction, position = scroll
    // fraction. Mirrors the "Nieuw Binnen" indicator, vertical. Transform-only.
    const sbScroll = document.getElementById('bomba-sidebar-scroll');
    const sbInd = document.getElementById('bomba-sidebar-indicator');
    const sbThumb = sbInd && sbInd.querySelector('.bomba-shop__sidebar-indicator-thumb');
    if (sbScroll && sbInd && sbThumb) {
      let sbTravel = 0;
      const sbLayout = () => {
        const scrollable = sbScroll.scrollHeight - sbScroll.clientHeight;
        if (scrollable <= 2) { sbInd.setAttribute('data-static', ''); sbTravel = 0; return; }
        sbInd.removeAttribute('data-static');
        const trackH = sbInd.clientHeight;
        const ratio = sbScroll.clientHeight / sbScroll.scrollHeight;
        const th = Math.max(trackH * ratio, 24);
        sbThumb.style.height = th + 'px';
        sbTravel = trackH - th;
      };
      const sbUpdate = () => {
        if (sbTravel <= 0) return;
        const scrollable = sbScroll.scrollHeight - sbScroll.clientHeight;
        let frac = scrollable > 0 ? sbScroll.scrollTop / scrollable : 0;
        frac = frac < 0 ? 0 : (frac > 1 ? 1 : frac);
        sbThumb.style.transform = 'translateY(' + (frac * sbTravel) + 'px)';
      };
      sbLayout(); sbUpdate();
      sbScroll.addEventListener('scroll', sbUpdate, { passive: true });
      window.addEventListener('resize', () => { sbLayout(); sbUpdate(); });
    }

    // Mobile Filter Drawer
    const openBtns = document.querySelectorAll('[data-open-filters]');
    const closeBtn = document.querySelector('.bomba-drawer__close');
    const drawer = document.querySelector('.bomba-drawer');
    const overlay = document.querySelector('.bomba-drawer__overlay');
    const panel = document.querySelector('.bomba-drawer__panel');
    const applyBtn = document.querySelector('.bomba-drawer__apply');
    let lastOpener = null;
    let closeTimer;

    // Open in two steps: mount (is-open) so the closed frame paints, then on
    // the NEXT frame add is-active so the transform transition runs from a
    // real start frame. Without the double-rAF the browser collapses both
    // into one frame and the slide "skips".
    const openDrawer = (e) => {
      if (!drawer) return;
      clearTimeout(closeTimer);
      lastOpener = e?.currentTarget || null;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        drawer.classList.add('is-active');
      }));
      const firstFocusable = panel?.querySelector('button, [href], input, select');
      if (firstFocusable) setTimeout(() => firstFocusable.focus(), 380);
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-active'); // slide out + overlay fade
      drawer.setAttribute('aria-hidden', 'true');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.style.overflow = '';
      // unmount after the slide finishes so the exit animation is visible
      closeTimer = setTimeout(() => drawer.classList.remove('is-open'), 460);
      if (lastOpener) lastOpener.focus();
    };

    // Batch apply: build the URL from the drawer's own inputs + the sort
    // select, so stale hidden sidebar inputs can't re-add removed filters.
    const applyDrawer = () => {
      if (!drawer) return;
      const baseUrl = drawer.getAttribute('data-collection-url') || window.location.pathname;
      const params = new URLSearchParams();
      const sortSel = document.querySelector('select[name="sort_by"]');
      if (sortSel && sortSel.value) params.set('sort_by', sortSel.value);
      drawer.querySelectorAll('[data-filter-input]').forEach((el) => {
        if (el.type === 'checkbox') {
          if (el.checked) params.append(el.name, el.value);
        } else if (el.value !== '' && el.value != null) {
          params.set(el.name, el.value);
        }
      });
      const qs = params.toString();
      window.location.href = qs ? baseUrl + '?' + qs : baseUrl;
    };

    // pointerdown fires the instant the finger lands (no touchend/click/hover
    // settle), so the menu starts opening immediately. click stays for
    // keyboard activation; openDrawer is idempotent so a double-call is safe.
    openBtns.forEach((b) => {
      b.addEventListener('pointerdown', openDrawer);
      b.addEventListener('click', openDrawer);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', applyDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    // ── Drag-to-close (handle + pull-past-top), one shared drag model ──
    // Both gestures feel identical:
    //  * the panel follows the finger 1:1 while dragging down (no easing lag);
    //  * release past HALF the panel height — or a fast downward flick — and
    //    the sheet completes the close on its own from that position;
    //  * release above half and it pops back up with a springy overshoot.
    if (panel) {
      const SPRING = 'transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1)';
      // Drag writes are decoupled from the input events: the touch/pointer
      // handlers only RECORD the finger position (cheap), and a rAF callback
      // applies exactly one transform write per displayed frame. Writing
      // styles inside every touchmove did more style invalidations than the
      // screen has frames, which is what made the drag feel sluggish.
      let dragY = 0, velY = 0, lastMoveY = 0, lastMoveT = 0;
      let activeDrag = false, originY = 0, pendingY = null, rafId = 0;

      const applyDrag = () => {
        rafId = 0;
        if (!activeDrag || pendingY === null) return;
        dragY = Math.max(0, pendingY - originY);
        panel.style.transform = 'translateY(' + dragY + 'px)';
      };
      const dragBegin = (origin) => {
        activeDrag = true;
        originY = origin;
        dragY = 0; velY = 0; lastMoveT = 0; pendingY = null;
        panel.style.transition = 'none'; // once per drag, not per move
      };
      const dragMove = (y) => {
        if (!activeDrag) return;
        const now = performance.now();
        if (lastMoveT) velY = (y - lastMoveY) / Math.max(1, now - lastMoveT); // px/ms, + = down
        lastMoveY = y; lastMoveT = now;
        pendingY = y;
        if (!rafId) rafId = window.requestAnimationFrame(applyDrag);
      };
      const dragEnd = () => {
        if (!activeDrag) return;
        activeDrag = false;
        if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; }
        if (pendingY !== null) dragY = Math.max(0, pendingY - originY); // final pos
        pendingY = null;
        const flick = velY > 0.6 && dragY > 40;
        if (dragY > panel.clientHeight * 0.5 || flick) {
          panel.style.transition = ''; // the CSS close curve takes over from here
          closeDrawer();
          panel.style.transform = '';
        } else {
          // Not far enough: pop back up with a slight overshoot, then hand
          // the transition back to the CSS curves.
          panel.style.transition = SPRING;
          panel.style.transform = '';
          const tidy = (e) => {
            if (e.propertyName !== 'transform') return;
            panel.style.transition = '';
            panel.removeEventListener('transitionend', tidy);
          };
          panel.addEventListener('transitionend', tidy);
        }
        dragY = 0; velY = 0; lastMoveT = 0;
      };

      // Handle: pressed animation + pointer drag (mouse and touch).
      const handleEl = panel.querySelector('.bomba-drawer__handle');
      if (handleEl) {
        let held = false, holdY = 0;
        const release = () => {
          if (!held) return;
          held = false;
          handleEl.classList.remove('is-pressed');
          dragEnd();
        };
        handleEl.addEventListener('pointerdown', (e) => {
          held = true;
          holdY = e.clientY;
          lastMoveY = e.clientY;
          dragBegin(holdY);
          handleEl.classList.add('is-pressed');
          handleEl.setPointerCapture(e.pointerId);
          e.preventDefault();
        });
        handleEl.addEventListener('pointermove', (e) => { if (held) dragMove(e.clientY); });
        handleEl.addEventListener('pointerup', release);
        handleEl.addEventListener('pointercancel', release);
      }

      // Pull-past-top: content already at the very top + keep pulling down
      // ~10px -> the drag picks the whole sheet up and it rides the finger
      // (offset by those 10px so there is no jump at activation). Only arms
      // when the touch STARTS at the top, so an upward scroll that lands on
      // top can never grab the sheet. passive:false is required: once the
      // drag activates, preventDefault() claims the gesture from the scroller.
      let touchY0 = null, armed = false, pulling = false;
      panel.addEventListener('touchstart', (e) => {
        // Touches that start on the handle belong to the pointer-drag above —
        // arming here too would double-drive the panel and jitter.
        if (e.target.closest('.bomba-drawer__handle')) { touchY0 = null; armed = false; return; }
        touchY0 = e.touches[0].clientY;
        armed = panel.scrollTop <= 0;
        pulling = false;
        lastMoveY = touchY0; lastMoveT = 0;
      }, { passive: true });
      panel.addEventListener('touchmove', (e) => {
        if (touchY0 === null || !armed) return;
        const y = e.touches[0].clientY;
        const dy = y - touchY0;
        if (!pulling) {
          if (panel.scrollTop > 0) { armed = false; return; } // became a scroll
          if (dy <= 0) return;                                // scrolling up: not ours
          // At the top and moving down: claim the gesture from the FIRST
          // pixel — otherwise iOS rubber-bands the content for the first few
          // px while the sheet then starts moving too, and that mix is what
          // made the drag feel off. A 4px arming threshold only filters tap
          // jitter; visually there is no dead zone.
          e.preventDefault();
          if (dy <= 4) return;
          pulling = true;
          dragBegin(touchY0 + 4);
        }
        e.preventDefault();
        dragMove(y);
      }, { passive: false });
      const touchDone = () => {
        if (pulling) dragEnd();
        touchY0 = null; armed = false; pulling = false;
      };
      panel.addEventListener('touchend', touchDone);
      panel.addEventListener('touchcancel', touchDone);
    }

    // Drawer sort pills -> drive the hidden sort_by select. applyDrawer reads
    // that select, so choosing a pill + "Toon resultaten" applies the sort.
    const drawerSortSelect = document.querySelector('select[name="sort_by"]');
    const drawerSortPills = document.querySelectorAll('[data-drawer-sort]');
    drawerSortPills.forEach((pill) => {
      pill.addEventListener('click', () => {
        drawerSortPills.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        if (drawerSortSelect) drawerSortSelect.value = pill.getAttribute('data-drawer-sort');
      });
    });

    // Custom dropdown logic
    document.querySelectorAll('[data-sort-dropdown]').forEach((dd) => {
      const btn = dd.querySelector('.bomba-shop__sort-btn');
      const label = dd.querySelector('[data-sort-current]');
      const menu = dd.querySelector('.bomba-shop__sort-menu');
      const sel = dd.querySelector('select');
      if (!btn || !menu || !sel) return;
      const close = () => {
        if (menu.hidden) return;
        menu.hidden = true;
        dd.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        menu.hidden = false;
        dd.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      };
      btn.addEventListener('click', () => (menu.hidden ? open() : close()));
      menu.querySelectorAll('[data-sort-value]').forEach((opt) => {
        opt.addEventListener('click', () => {
          menu.querySelectorAll('[data-sort-value]').forEach((o) => {
            o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
          });
          if (label) label.textContent = opt.textContent.trim();
          close();
          sel.value = opt.getAttribute('data-sort-value');
          sel.dispatchEvent(new Event('change'));
        });
      });
      document.addEventListener('pointerdown', (e) => {
        if (!dd.contains(e.target)) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
      // Expose close for the scroll-hide logic
      dd.closeSort = close;
    });

    // Controls toolbar behaviour — same on phone and desktop.
    // NB: Liquid ({{ ... }}) is NOT rendered inside {% javascript %} (bundled
    // into a shared theme.js), so select by class only.
    //
    // The bar is position:static by default: on the way DOWN it is just normal
    // content and scrolls off the page — nothing happens. The reveal mechanics
    // only start once it is FULLY past the navbar:
    //   stickPoint = naturalTop - headerBottom          (natural top meets navbar)
    //   offScreen  = naturalTop + barHeight - headerBottom (bar fully behind it)
    // Enter docked at offScreen (add .is-docked -> position:sticky, which
    // reserves the bar's space so nothing jumps and keeps the column width;
    // start hidden). Then up = slide in, down = slide out. Leave docked at
    // stickPoint, where the docked and natural positions line up so the hand-off
    // is seamless. Mode flips that must not animate get .no-anim for one frame.
    // --bomba-plp-sticky-top is the measured bottom edge of the header stack
    // (USP/info bar + navbar), so the docked bar pins flush under it.
    const controls = document.querySelector('.bomba-shop__controls');
    if (controls) {
      const shopRoot = controls.closest('.bomba-shop') || document.documentElement;
      const headerStack = document.getElementById('js-header-wrapper');

      let headerBottom = 111, naturalTop = 0, barHeight = 0, lastY = window.scrollY, docked = false, ticking = false;

      const setTop = () => {
        headerBottom = headerStack ? Math.round(headerStack.getBoundingClientRect().bottom) : headerBottom;
        shopRoot.style.setProperty('--bomba-plp-sticky-top', headerBottom + 'px');
      };
      // Natural document offset + height, read in the plain static state.
      const measure = () => {
        const wasDocked = controls.classList.contains('is-docked');
        const wasHidden = controls.classList.contains('is-hidden');
        controls.classList.add('no-anim');
        controls.classList.remove('is-docked', 'is-hidden');
        const r = controls.getBoundingClientRect();
        naturalTop = Math.round(r.top + window.scrollY);
        barHeight = Math.round(r.height);
        if (wasDocked) controls.classList.add('is-docked');
        if (wasHidden) controls.classList.add('is-hidden');
        void controls.offsetHeight;            // commit without a transition
        controls.classList.remove('no-anim');
      };
      // Flip the docked state without a transition flash. On dock, freeze the
      // hide distance (bar height + header + margin) into --plp-hide so the
      // slide animates against a stable target. The open picker never needs
      // covering: the scroll listener above closes it on the first tick.
      const closeSortMenu = () => {
        const dd = controls.querySelector('[data-sort-dropdown]');
        if (dd && dd.closeSort) dd.closeSort();
      };
      
      const setDocked = (on, hidden) => {
        if (on) {
          if (hidden) closeSortMenu();
          controls.style.setProperty('--plp-hide', '-' + (barHeight + headerBottom + 24) + 'px');
        }
        controls.classList.add('no-anim');
        controls.classList.toggle('is-docked', on);
        controls.classList.toggle('is-hidden', on && hidden);
        void controls.offsetHeight;
        controls.classList.remove('no-anim');
        docked = on;
      };

      const hideBar = () => {
        if (controls.classList.contains('is-hidden')) return;
        closeSortMenu(); // Smoothly close immediately on slide out
        const dist = barHeight + headerBottom + 24;
        controls.style.setProperty('--plp-hide', '-' + dist + 'px');
        controls.style.setProperty('--plp-hide-ms', '450ms'); // Fixed smooth speed
        controls.classList.add('is-hidden');
      };

      controls.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'transform' || e.target !== controls) return;
        if (!controls.classList.contains('is-hidden')) return;
        // It's already closed, but we reset the distance just in case
        controls.classList.add('no-anim');
        controls.style.setProperty('--plp-hide', '-' + (barHeight + headerBottom + 24) + 'px');
        void controls.offsetHeight;
        controls.classList.remove('no-anim');
      });

      const onScroll = () => {
        ticking = false;
        setTop(); // header shrinks 91->75px mid-scroll; keep the offset current
        const y = window.scrollY, dy = y - lastY;
        lastY = y;
        
        const stickPoint = naturalTop - headerBottom;
        const offScreen = naturalTop + barHeight - headerBottom;

        if (!docked) {
          if (y >= offScreen) setDocked(true, true); // fully gone -> dock (hidden)
          return;                                     // otherwise: pure static flow
        }
        if (y <= stickPoint) { setDocked(false, false); return; } // back to its place
        if (dy > 1) hideBar();                                    // down -> slide out
        else if (dy < -1) controls.classList.remove('is-hidden'); // up -> slide in
      };

      const remeasure = () => { measure(); setTop(); onScroll(); };
      measure();
      setTop();
      onScroll();
      window.addEventListener('scroll', () => {
        if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });
      // Mobile browsers fire resize when the URL bar collapses/expands mid-
      // scroll; remeasure() toggles .no-anim with a forced reflow, which kills
      // an in-flight slide and makes the bar snap instantly. A height-only
      // resize can't change the bar's natural offset or width, so only
      // remeasure when the viewport WIDTH actually changes.
      let lastW = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        window.requestAnimationFrame(remeasure);
      }, { passive: true });
      window.addEventListener('load', remeasure);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bomba-wishlist"] && !Shopify.designMode) return;
  try {
    
  class BombaWishlist {
    constructor(root) {
      this.root = root;
      this.STORAGE_KEY = 'bomba_wishlist';
      this.SHIPPING_THRESHOLD = parseInt(root.dataset.shippingThreshold, 10) || 7500;
      this.SORT_KEY = 'bomba_wishlist_sort';
      this.sort = localStorage.getItem(this.SORT_KEY) || 'added-desc';
      this.previewItems = this.readPreviewItems(root);
      this.items = this.load();
      this.customerId = root.dataset.customerId || '';
      this.recsUrl = root.dataset.recsUrl || '/recommendations/products';
      this._recSig = null;   // signature of the wishlist the current recs were built from
      this._recReq = 0;      // monotonic id to drop superseded async fetches
      this.dateFmt = new Intl.RelativeTimeFormat('nl-NL', { numeric: 'auto' });
      this.priceFmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
      this.init();
    }

    // Editable copy arrives through data-str-* attributes on the root, because
    // this script runs from the theme bundle and cannot read Liquid.
    t(key, fallback) {
      return this.root.dataset[key] || fallback;
    }

    // Theme-editor preview: a fixed list of products from the section setting,
    // used instead of localStorage so editing never touches a real wishlist.
    readPreviewItems(root) {
      if (root.dataset.previewItems == null) return null;
      try {
        const day = 1000 * 60 * 60 * 24;
        const list = JSON.parse(root.dataset.previewItems);
        return list.map((item, i) => ({ ...item, addedAt: Date.now() - i * day }));
      } catch (e) {
        return [];
      }
    }

    load() {
      if (this.previewItems) return this.previewItems.map(item => ({ ...item }));
      try {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        const parsed = stored ? JSON.parse(stored) : [];
        return parsed.map(item => item.addedAt ? item : { ...item, addedAt: Date.now() });
      } catch (e) {
        console.error('Wishlist load failed:', e);
        return [];
      }
    }

    save() {
      try {
        if (!this.previewItems) localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.items));
      } catch (e) {
        console.error('Wishlist save failed:', e);
      }
      this.updateUI();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: this.items, _origin: 'page' } }));
    }

    addItem(product) {
      if (!this.items.find(i => i.id == product.id)) {
        this.items.push({ ...product, addedAt: Date.now() });
        this.save();
      }
    }

    removeItem(id) {
      const card = this.root.querySelector(`[data-card-id="${id}"]`);
      const finalize = () => {
        this.items = this.items.filter(i => i.id != id);
        this.save();
      };
      if (card) {
        card.classList.add('bomba-wl__card--removing');
        setTimeout(finalize, 280);
      } else {
        finalize();
      }
    }

    clear() {
      if (this.items.length === 0) return;
      this.openClearModal();
    }

    openClearModal() {
      const modal = this._clearModal;
      if (!modal) {
        // Fallback if markup is missing.
        if (confirm('Weet je zeker dat je jouw verlanglijst wilt wissen?')) {
          this.items = [];
          this.save();
        }
        return;
      }
      modal.hidden = false;
      document.body.classList.add('bomba-wl-modal-open');
      this._modalKeyHandler = (e) => { if (e.key === 'Escape') this.closeClearModal(); };
      document.addEventListener('keydown', this._modalKeyHandler);
      const confirmBtn = modal.querySelector('[data-clear-confirm]');
      if (confirmBtn) confirmBtn.focus();
    }

    closeClearModal() {
      const modal = this._clearModal;
      if (modal) modal.hidden = true;
      document.body.classList.remove('bomba-wl-modal-open');
      if (this._modalKeyHandler) {
        document.removeEventListener('keydown', this._modalKeyHandler);
        this._modalKeyHandler = null;
      }
    }

    getSorted() {
      const arr = [...this.items];
      switch (this.sort) {
        case 'added-asc':  return arr.sort((a, b) => (a.addedAt || 0) - (b.addedAt || 0));
        case 'price-asc':  return arr.sort((a, b) => (a.price || 0) - (b.price || 0));
        case 'price-desc': return arr.sort((a, b) => (b.price || 0) - (a.price || 0));
        default:           return arr.sort((a, b) => (b.addedAt || 0) - (a.addedAt || 0));
      }
    }

    formatRelative(ts) {
      if (!ts) return '';
      const diffMs = ts - Date.now();
      const days = Math.round(diffMs / (1000 * 60 * 60 * 24));
      if (Math.abs(days) >= 1)   return 'Bewaard ' + this.dateFmt.format(days, 'day');
      const hours = Math.round(diffMs / (1000 * 60 * 60));
      if (Math.abs(hours) >= 1)  return 'Bewaard ' + this.dateFmt.format(hours, 'hour');
      const mins = Math.round(diffMs / (1000 * 60));
      if (Math.abs(mins) >= 1)   return 'Bewaard ' + this.dateFmt.format(mins, 'minute');
      return 'Zojuist bewaard';
    }

    formatPrice(cents) {
      return this.priceFmt.format((cents || 0) / 100);
    }

    init() {
      const clearBtn = this.root.querySelector('[data-clear-wishlist]');
      clearBtn && clearBtn.addEventListener('click', () => this.clear());

      // Portal the confirm modal to <body> so its fixed overlay + backdrop blur
      // resolve against the viewport, not a transformed/filtered ancestor.
      const modal = this.root.querySelector('[data-clear-modal]');
      if (modal) {
        document.body.appendChild(modal);
        this._clearModal = modal;
        modal.querySelectorAll('[data-clear-cancel]').forEach(el =>
          el.addEventListener('click', () => this.closeClearModal())
        );
        const clearConfirm = modal.querySelector('[data-clear-confirm]');
        clearConfirm && clearConfirm.addEventListener('click', () => {
          this.items = [];
          this.save();
          this.closeClearModal();
        });
      }

      const shareBtn = this.root.querySelector('[data-share-wishlist]');
      shareBtn && shareBtn.addEventListener('click', () => this.shareWishlist());

      const toastClose = this.root.querySelector('[data-share-toast-close]');
      toastClose && toastClose.addEventListener('click', () => this.hideShareToast());

      const saveSharedBtn = this.root.querySelector('[data-save-shared-wishlist]');
      saveSharedBtn && saveSharedBtn.addEventListener('click', () => this.saveSharedToWishlist());

      this.initSortDropdown();

      const addAllBtn = this.root.querySelector('[data-wishlist-add-all]');
      addAllBtn && addAllBtn.addEventListener('click', () => this.addAllToCart(addAllBtn));

      document.addEventListener('wishlist:add', (e) => {
        if (e.detail && e.detail.product) this.addItem(e.detail.product);
      });

      // Heart buttons (e.g. in recommendations) update localStorage directly and dispatch
      // wishlist:updated without _origin — pick those up to refresh the grid + filterRecs instantly.
      document.addEventListener('wishlist:updated', (e) => {
        if (!e.detail?._origin) {
          this.items = this.load();
          this.updateUI();
        }
      });

      window.addEventListener('storage', (e) => {
        if (e.key === this.STORAGE_KEY) {
          this.items = this.load();
          this.updateUI();
        }
      });

      // Check for ?share= URL parameter
      // In the theme editor (with the shared-view preview switched on) the
      // section hands us a few real product handles, so the shared view can be
      // previewed and edited without a ?share= link.
      const shareParam = new URLSearchParams(window.location.search).get('share')
        || this.root.dataset.previewShare;
      if (shareParam) {
        this.initSharedMode(shareParam);
      } else {
        this.updateUI();
      }
    }

    // ── Custom sort dropdown ──────────────────────────────────

    initSortDropdown() {
      const wrap    = this.root.querySelector('[data-wishlist-sort-wrap]');
      const trigger = this.root.querySelector('[data-wishlist-sort-trigger]');
      const menu    = this.root.querySelector('[data-wishlist-sort-menu]');
      const valueEl = this.root.querySelector('[data-wishlist-sort-value]');
      if (!wrap || !trigger || !menu) return;

      // Portal the menu to <body> so no transformed/filtered ancestor (hero
      // intro animation, section wrappers) can hijack its fixed positioning.
      document.body.appendChild(menu);

      const options = Array.from(menu.querySelectorAll('[data-value]'));

      const syncSelected = () => {
        options.forEach(opt => {
          const active = opt.dataset.value === this.sort;
          opt.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && valueEl) valueEl.textContent = opt.textContent.trim();
        });
      };

      // Position the menu with fixed coords clamped to the viewport, so it can
      // never spill off-screen (the old right:0 absolute push ran off the left
      // edge on phones). Right-aligned to the trigger when there's room.
      const positionMenu = () => {
        const r = trigger.getBoundingClientRect();
        const margin = 8;
        const w = Math.min(menu.offsetWidth, window.innerWidth - margin * 2);
        let left = r.right - w;                                   // right-align to trigger
        left = Math.max(margin, Math.min(left, window.innerWidth - w - margin));
        menu.style.position = 'fixed';
        menu.style.top = (r.bottom + margin) + 'px';
        menu.style.left = left + 'px';
        menu.style.right = 'auto';
      };

      const close = () => {
        if (menu.hidden) return;
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocClick, true);
        document.removeEventListener('keydown', onKeydown, true);
        window.removeEventListener('resize', positionMenu);
        window.removeEventListener('scroll', positionMenu, true);
      };

      const open = () => {
        if (!menu.hidden) return;
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        positionMenu();
        document.addEventListener('click', onDocClick, true);
        document.addEventListener('keydown', onKeydown, true);
        window.addEventListener('resize', positionMenu);
        window.addEventListener('scroll', positionMenu, true);
      };

      const onDocClick = (e) => { if (!wrap.contains(e.target) && !menu.contains(e.target)) close(); };
      const onKeydown  = (e) => { if (e.key === 'Escape') { close(); trigger.focus(); } };

      trigger.addEventListener('click', () => (menu.hidden ? open() : close()));

      options.forEach(opt => {
        opt.addEventListener('click', () => {
          this.sort = opt.dataset.value;
          localStorage.setItem(this.SORT_KEY, this.sort);
          syncSelected();
          close();
          this.updateUI();
        });
      });

      syncSelected();
    }

    // ── Share functionality ───────────────────────────────────

    // base64url encode (URL-safe, no padding) so the shared item handles aren't
    // legible in the link.
    _encodeShare(str) {
      return btoa(unescape(encodeURIComponent(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    }

    // Decode a base64url share blob back to its plaintext handle list. Returns
    // null if the input isn't valid base64url (i.e. a legacy plaintext link).
    _decodeShare(str) {
      try {
        const b64 = str.replace(/-/g, '+').replace(/_/g, '/');
        const padded = b64 + '='.repeat((4 - b64.length % 4) % 4);
        const out = decodeURIComponent(escape(atob(padded)));
        return /^[a-z0-9][a-z0-9\-,]*$/.test(out) ? out : null;
      } catch (e) {
        return null;
      }
    }

    getShareUrl() {
      const handles = this.items
        .map(item => {
          const url = item.url || '';
          const match = url.match(/\/products\/([^?#/]+)/);
          return match ? match[1] : null;
        })
        .filter(Boolean);
      if (handles.length === 0) return null;
      // userid (who shared) stays in the URL; the product handles are base64url
      // encoded so they're not readable at a glance.
      const params = new URLSearchParams();
      if (this.customerId) params.set('u', this.customerId);
      params.set('share', this._encodeShare(handles.join(',')));
      return `${window.location.origin}/pages/wishlist?${params.toString()}`;
    }

    shareWishlist() {
      const url = this.getShareUrl();
      if (!url) return;

      if (navigator.share) {
        navigator.share({
          title: this.t('strShareTitle', 'Mijn verlanglijst'),
          text: this.t('strShareText', 'Kijk eens naar mijn verlanglijst bij Cozy!'),
          url
        }).catch(() => this.copyShareUrl(url));
      } else {
        this.copyShareUrl(url);
      }
    }

    copyShareUrl(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => this.showShareToast());
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        this.showShareToast();
      }
    }

    showShareToast() {
      const toast = this.root.querySelector('[data-share-toast]');
      if (!toast) return;
      toast.hidden = false;
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => this.hideShareToast(), 4000);
    }

    hideShareToast() {
      const toast = this.root.querySelector('[data-share-toast]');
      if (toast) toast.hidden = true;
    }

    // ── Shared wishlist mode (viewing someone else's list) ────

    async initSharedMode(shareParam) {
      // New links are base64url encoded; legacy links are a plaintext comma list.
      const decoded = this._decodeShare(shareParam.trim());
      const source = decoded != null ? decoded : shareParam;
      const handles = source.split(',').map(h => h.trim()).filter(Boolean);
      if (handles.length === 0) { this.updateUI(); return; }

      // Hide own wishlist UI, show shared view
      const main = this.root.querySelector('.bomba-wl__main');
      if (main) main.hidden = true;
      const guestEl = this.root.querySelector('[data-wishlist-guest]');
      if (guestEl) guestEl.hidden = true;

      const wrapper = this.root.querySelector('[data-wishlist-shared-wrapper]');
      if (wrapper) wrapper.hidden = false;

      // Update page heading
      const titleEl = this.root.querySelector('[data-wishlist-title]');
      if (titleEl) titleEl.textContent = this.root.dataset.sharedHeading || 'Gedeelde verlanglijst';

      const grid = this.root.querySelector('[data-shared-grid]');
      if (!grid) return;

      // Fetch each product by handle
      const products = await Promise.all(
        handles.map(handle =>
          fetch(`/products/${handle}.js`)
            .then(r => r.ok ? r.json() : null)
            .catch(() => null)
        )
      );

      this.sharedItems = products
        .filter(Boolean)
        .map(p => ({
          id: String(p.id),
          variantId: String(p.variants?.[0]?.id || ''),
          name: p.title,
          price: p.price,
          url: p.url,
          handle: p.handle,
          image: p.featured_image || ''
        }));

      const template = document.getElementById('bomba-shared-item-temp');
      if (!template) return;

      grid.replaceChildren();
      this.sharedItems.forEach((item, index) => {
        const clone = template.content.cloneNode(true);
        const card = clone.querySelector('.bomba-wl__card');

        const img = clone.querySelector('[data-item-image]');
        const placeholder = clone.querySelector('[data-item-image-placeholder]');
        const links = clone.querySelectorAll('[data-item-link]');
        const name = clone.querySelector('[data-item-name]');
        const price = clone.querySelector('[data-item-price]');
        const atcBtn = clone.querySelector('[data-item-atc]');

        if (item.image) {
          img.src = item.image;
          img.alt = item.name || '';
        } else {
          img.hidden = true;
          if (placeholder) placeholder.hidden = false;
        }

        links.forEach(l => { l.href = item.url || '#'; });
        if (name) name.textContent = item.name || '';
        if (price) price.textContent = this.formatPrice(item.price);

        if (atcBtn) {
          if (!item.variantId) {
            atcBtn.disabled = true;
          } else {
            atcBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.handleAddToCart(atcBtn, item.variantId);
            });
          }
        }

        grid.appendChild(clone);
        const cardEl = grid.lastElementChild;

        requestAnimationFrame(() => {
          setTimeout(() => {
            cardEl && cardEl.classList.add('bomba-wl__card--visible');
          }, index * 45);
        });
      });

      if (this.sharedItems.length > 0) {
        const actionsEl = this.root.querySelector('[data-shared-actions]');
        if (actionsEl) actionsEl.hidden = false;
      }
    }

    saveSharedToWishlist() {
      if (!this.sharedItems || this.sharedItems.length === 0) return;
      this.sharedItems.forEach(item => this.addItem(item));
      const btn = this.root.querySelector('[data-save-shared-wishlist]');
      if (btn) {
        btn.textContent = this.root.dataset.sharedSavedLabel || 'Bewaard op je verlanglijst';
        btn.disabled = true;
      }
    }

    updateUI() {
      const empty       = this.root.querySelector('[data-wishlist-empty]');
      const filled      = this.root.querySelector('[data-wishlist-filled]');
      const toolbar     = this.root.querySelector('[data-wishlist-toolbar]');
      const summary     = this.root.querySelector('[data-wishlist-summary]');
      const grid        = this.root.querySelector('[data-wishlist-grid]');
      const counts      = this.root.querySelectorAll('[data-wishlist-count-display]');
      const summaryCnt  = this.root.querySelector('[data-wishlist-summary-count]');
      const totalEl     = this.root.querySelector('[data-wishlist-total-price]');
      const shipping    = this.root.querySelector('[data-shipping-hint]');

      const count = this.items.length;
      const countLabel = count === 1
        ? this.t('strCountOne', '1 item bewaard')
        : this.t('strCountOther', '[aantal] items bewaard').replace('[aantal]', count);

      counts.forEach(el => { el.textContent = count === 0 ? 'Je hebt nog niets bewaard' : countLabel; });
      if (summaryCnt) summaryCnt.textContent = countLabel;

      if (count === 0) {
        empty && empty.classList.add('is-active');
        if (filled)  filled.hidden  = true;
        if (toolbar) toolbar.hidden = true;
        if (summary) summary.hidden = true;
        this._recSig = null;   // next item added re-personalizes from scratch
        return;
      }

      empty && empty.classList.remove('is-active');
      if (filled)  filled.hidden  = false;
      if (toolbar) toolbar.hidden = false;
      if (summary) summary.hidden = false;

      if (grid) {
        grid.replaceChildren();
        const template = document.getElementById('bomba-wishlist-item-temp');
        const sorted = this.getSorted();

        sorted.forEach((item, index) => {
          const clone = template.content.cloneNode(true);
          const card  = clone.querySelector('.bomba-wl__card');
          card.dataset.cardId = item.id;

          const img         = clone.querySelector('[data-item-image]');
          const placeholder = clone.querySelector('[data-item-image-placeholder]');
          const links       = clone.querySelectorAll('[data-item-link]');
          const name        = clone.querySelector('[data-item-name]');
          const saved       = clone.querySelector('[data-item-saved]');
          const price       = clone.querySelector('[data-item-price]');
          const removeBtn   = clone.querySelector('[data-item-remove]');
          const atcBtn      = clone.querySelector('[data-item-atc]');

          if (item.image) {
            img.src = item.image;
            img.alt = item.name || '';
          } else {
            img.hidden = true;
            placeholder.hidden = false;
          }

          links.forEach(l => l.href = item.url || '#');
          name.textContent  = item.name || '';
          saved.textContent = this.formatRelative(item.addedAt);
          price.textContent = this.formatPrice(item.price);

          if (!item.variantId) {
            atcBtn.disabled = true;
            atcBtn.title = 'Open productpagina voor varianten';
          }

          removeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.removeItem(item.id);
          });

          atcBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleAddToCart(atcBtn, item.variantId);
          });

          grid.appendChild(clone);

          requestAnimationFrame(() => {
            setTimeout(() => {
              const el = grid.querySelector(`[data-card-id="${item.id}"]`);
              el && el.classList.add('bomba-wl__card--visible');
            }, index * 45);
          });
        });
      }

      const total = this.items.reduce((sum, i) => sum + (i.price || 0), 0);
      if (totalEl) totalEl.textContent = this.formatPrice(total);

      if (shipping) this.renderShipping(shipping, total);
      // Static fallback first (instant), then swap in personalized recs.
      this.filterRecs();
      this.personalizeRecs();
    }

    filterRecs() {
      const wishlistIds = new Set(this.items.map(i => String(i.id)));
      this.root.querySelectorAll('.bomba-wl__rec-grid').forEach(grid => {
        let shown = 0;
        grid.querySelectorAll('.bomba-wl__rec[data-product-id]').forEach(el => {
          if (wishlistIds.has(el.dataset.productId) || shown >= 4) {
            el.style.display = 'none';
          } else {
            el.style.display = '';
            shown++;
          }
        });
      });
    }

    // Personalize the filled-state recommendations off the wishlist contents,
    // using Shopify's Product Recommendations API (intent=related) — the same
    // engine the PDP "Misschien vind je dit ook leuk" carousel uses. Each saved
    // item votes for its related products; products recommended by several saved
    // items rank first (the "type" signal). Falls back to the server-rendered
    // collection when the wishlist is empty or the API returns nothing.
    async personalizeRecs() {
      const grid = this.root.querySelector('.bomba-wl__recs--bottom .bomba-wl__rec-grid');
      if (!grid) return;

      const ids = this.items.map(i => String(i.id)).filter(Boolean);
      if (ids.length === 0) return;

      const sig = ids.slice().sort().join(',');
      if (sig === this._recSig) return;   // wishlist unchanged → keep current recs
      this._recSig = sig;
      const reqId = ++this._recReq;

      const base = this.recsUrl || '/recommendations/products';
      const endpoint = base.endsWith('.json') ? base : base + '.json';
      const wishlistSet = new Set(ids);
      const seeds = ids.slice(0, 8);      // cap concurrent requests

      try {
        const results = await Promise.all(seeds.map(id =>
          fetch(`${endpoint}?product_id=${encodeURIComponent(id)}&intent=related&limit=10`, {
            headers: { 'Accept': 'application/json' }
          }).then(r => (r.ok ? r.json() : null)).catch(() => null)
        ));
        if (reqId !== this._recReq) return;   // a newer change superseded this run

        const tally = new Map();   // productId → { score, idx, product }
        results.forEach(res => {
          const prods = res && res.products;
          if (!Array.isArray(prods)) return;
          prods.forEach((p, idx) => {
            const pid = String(p.id);
            if (wishlistSet.has(pid)) return;   // never recommend something already saved
            const cur = tally.get(pid);
            if (cur) cur.score += 1;
            else tally.set(pid, { score: 1, idx, product: p });
          });
        });

        const ranked = [...tally.values()]
          .sort((a, b) => b.score - a.score || a.idx - b.idx)
          .slice(0, 4)
          .map(x => x.product);

        if (ranked.length === 0) { this._recSig = null; return; }  // keep fallback, allow retry
        this.renderRecCards(grid, ranked);
      } catch (e) {
        console.error('Wishlist recs failed:', e);
        this._recSig = null;   // allow a retry on the next wishlist change
      }
    }

    // Build rec cards with safe DOM construction (no innerHTML). The heart button
    // mirrors snippets/bomba-wishlist-button.liquid's data contract so the global
    // delegated handler toggles + persists it with no extra wiring.
    renderRecCards(grid, products) {
      grid.replaceChildren();

      products.forEach(p => {
        const imgSrc = p.featured_image || (Array.isArray(p.images) && p.images[0]) || '';
        const variantId = (Array.isArray(p.variants) && p.variants[0] && p.variants[0].id) || '';

        const card = document.createElement('div');
        card.className = 'bomba-wl__rec';
        card.dataset.productId = String(p.id);

        const media = document.createElement('div');
        media.className = 'bomba-wl__rec-media';
        const mediaLink = document.createElement('a');
        mediaLink.className = 'bomba-wl__rec-media-link';
        mediaLink.href = p.url || '#';
        if (imgSrc) {
          const img = document.createElement('img');
          img.className = 'bomba-wl__rec-img';
          img.loading = 'lazy';
          img.src = imgSrc;
          img.alt = p.title || '';
          mediaLink.appendChild(img);
        }
        media.appendChild(mediaLink);

        const btnWrap = document.createElement('div');
        btnWrap.className = 'bomba-wl__rec-wl-btn';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bomba-wishlist-toggle';
        btn.setAttribute('data-add-to-wishlist', '');
        btn.dataset.productId = String(p.id);
        btn.setAttribute('aria-label', 'Voeg toe aan verlanglijst');
        btn.dataset.product = JSON.stringify({
          id: String(p.id),
          variantId: String(variantId),
          name: p.title || '',
          price: p.price || 0,
          url: p.url || '',
          image: imgSrc
        });
        const heartOutline = document.createElement('span');
        heartOutline.className = 'material-symbols-outlined heart-icon';
        heartOutline.setAttribute('aria-hidden', 'true');
        heartOutline.textContent = 'favorite_border';
        const heartFilled = document.createElement('span');
        heartFilled.className = 'material-symbols-outlined heart-icon heart-icon--filled';
        heartFilled.setAttribute('aria-hidden', 'true');
        heartFilled.style.display = 'none';
        heartFilled.textContent = 'favorite';
        btn.appendChild(heartOutline);
        btn.appendChild(heartFilled);
        btnWrap.appendChild(btn);
        media.appendChild(btnWrap);

        const link = document.createElement('a');
        link.className = 'bomba-wl__rec-link';
        link.href = p.url || '#';
        const name = document.createElement('p');
        name.className = 'bomba-wl__rec-name';
        name.textContent = p.title || '';
        const price = document.createElement('p');
        price.className = 'bomba-wl__rec-price';
        price.textContent = this.formatPrice(p.price);
        link.appendChild(name);
        link.appendChild(price);

        card.appendChild(media);
        card.appendChild(link);
        grid.appendChild(card);
      });

      // Sync the freshly built hearts' active state (origin tag avoids a re-render loop).
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: this.items, _origin: 'recs' } }));
    }

    renderShipping(container, total) {
      const remaining  = Math.max(0, this.SHIPPING_THRESHOLD - total);
      const percentage = Math.min(100, (total / this.SHIPPING_THRESHOLD) * 100);

      container.replaceChildren();

      if (total === 0) {
        container.dataset.empty = 'true';
        const tpl = document.getElementById('bomba-wl-shipping-empty');
        const node = tpl.content.cloneNode(true);
        const thresholdEl = node.querySelector('[data-threshold]');
        if (thresholdEl) thresholdEl.textContent = this.formatPrice(this.SHIPPING_THRESHOLD);
        container.appendChild(node);
        return;
      }

      container.dataset.empty = 'false';

      if (remaining > 0) {
        const tpl = document.getElementById('bomba-wl-shipping-progress');
        const node = tpl.content.cloneNode(true);
        const remEl     = node.querySelector('[data-remaining]');
        const percentEl = node.querySelector('[data-percent]');
        const fillEl    = node.querySelector('[data-fill]');
        if (remEl)     remEl.textContent     = this.formatPrice(remaining);
        if (percentEl) percentEl.textContent = `${Math.round(percentage)}%`;
        if (fillEl)    fillEl.style.width    = `${percentage}%`;
        container.appendChild(node);
      } else {
        const tpl = document.getElementById('bomba-wl-shipping-done');
        container.appendChild(tpl.content.cloneNode(true));
      }
    }

    async handleAddToCart(btn, variantId) {
      if (!variantId) {
        alert('Open de productpagina om een variant te kiezen.');
        return;
      }
      const labelEl = btn.querySelector('.bomba-wl__card-cta-label');
      const original = labelEl ? labelEl.textContent : '';

      btn.dataset.state = 'loading';
      if (labelEl) labelEl.textContent = this.t('strBusy', 'Bezig…');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('cart add failed');
        btn.dataset.state = 'done';
        if (labelEl) labelEl.textContent = this.t('strAdded', 'Toegevoegd');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { quantity: 1 } }));
        setTimeout(() => {
          btn.dataset.state = '';
          if (labelEl) labelEl.textContent = original;
        }, 1800);
      } catch (err) {
        console.error('Wishlist ATC error:', err);
        btn.dataset.state = 'error';
        if (labelEl) labelEl.textContent = this.t('strRetry', 'Probeer opnieuw');
        setTimeout(() => {
          btn.dataset.state = '';
          if (labelEl) labelEl.textContent = original;
        }, 2200);
      }
    }

    async addAllToCart(btn) {
      const addable = this.items.filter(i => i.variantId);
      if (addable.length === 0) {
        alert('Geen direct toevoegbare items. Open een productpagina om een variant te kiezen.');
        return;
      }
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = this.t('strBusy', 'Bezig…');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addable.map(i => ({ id: i.variantId, quantity: 1 })) })
        });
        if (!res.ok) throw new Error('bulk add failed');
        btn.textContent = this.t('strAddedAll', '[aantal] toegevoegd').replace('[aantal]', addable.length);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { quantity: addable.length } }));
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('Bulk add error:', err);
        btn.textContent = this.t('strRetry', 'Probeer opnieuw');
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2200);
      }
    }
  }

  (function () {
    const init = () => {
      document.querySelectorAll('.bomba-wl').forEach(root => {
        root.style.paddingBottom = '0';
        if (root.dataset.wlInit) return;
        root.dataset.wlInit = '1';
        window.bombaWishlistInstance = new BombaWishlist(root);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail && e.detail.sectionId.includes('BombaWishlist')) {
        const root = document.querySelector(`#BombaWishlist-${e.detail.sectionId}`);
        if (root) {
          delete root.dataset.wlInit;
          init();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Staggered entrance animation for product cards
    const cards = document.querySelectorAll('.bomba-product-card');
    if (cards.length > 0 && typeof gsap !== 'undefined') {
      gsap.set(cards, { opacity: 0, y: 24 });
      gsap.to(cards, { opacity: 1, y: 0, duration: 0.7, stagger: 0.06, ease: 'power3.out', clearProps: 'transform' });
    }

    // ── Sort select — client-side, no page reload ──
    const sortGrid = (value) => {
      const grid = document.querySelector('.bomba-shop__grid');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-card]')];
      cards.sort((a, b) => {
        if (value === 'price-ascending')  return parseInt(a.dataset.price) - parseInt(b.dataset.price);
        if (value === 'price-descending') return parseInt(b.dataset.price) - parseInt(a.dataset.price);
        // relevance = original server order
        return parseInt(a.dataset.index) - parseInt(b.dataset.index);
      });
      cards.forEach(c => grid.appendChild(c));
    };
    document.querySelectorAll('[data-sort-select]').forEach((sel) => {
      sel.addEventListener('change', () => sortGrid(sel.value));
    });

    // ── Filter form auto-submit (checkboxes + price inputs; sidebar only) ──
    const filterForm = document.getElementById('bomba-plp-filter-form');
    if (filterForm) {
      let debounceTimer;
      // Build the URL from the sidebar's own inputs only — never a native
      // filterForm.submit(). Native submit always includes the price inputs even
      // when empty (an empty `lte=`/`gte=` returns zero results), so a cleared
      // price field couldn't drop its bound. Mirrors applyDrawer.
      const baseUrl = filterForm.getAttribute('action') || '{{ routes.search_url }}';
      // NB: Liquid is NOT rendered inside {% javascript %} (it is bundled into
      // a shared theme.js), so we cannot inline the search term here — doing so
      // literally emitted "{{ search.terms | escape }}" as the q value. Read the
      // real, already-encoded term from the current URL instead (falls back to
      // the Liquid-rendered hidden input the form carries).
      const currentQ = new URLSearchParams(window.location.search).get('q')
        || filterForm.querySelector('input[name="q"]')?.value
        || '';
      const submit = () => {
        const params = new URLSearchParams();
        params.set('q', currentQ);
        params.set('type', 'product');
        document.querySelectorAll('[data-filter-input]').forEach((el) => {
          if (el.closest('.bomba-drawer')) return; // skip the drawer's duplicate inputs
          if (el.name === 'q' || el.name === 'type') return; // set above
          if (el.type === 'checkbox') {
            if (el.checked) params.append(el.name, el.value);
          } else if (el.value !== '' && el.value != null) {
            params.set(el.name, el.value);
          }
        });
        const qs = params.toString();
        window.location.href = qs ? baseUrl + '?' + qs : baseUrl;
      };
      // Enter in a price field would otherwise native-submit the form.
      filterForm.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
      document.querySelectorAll('[data-filter-input]').forEach((input) => {
        if (input.closest('.bomba-drawer')) return;
        const isText = input.tagName === 'INPUT' && (input.type === 'number' || input.type === 'text');
        input.addEventListener('change', submit);
        if (isText) {
          input.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(submit, 600);
          });
        }
      });
    }

    // ── Mobile Filter Drawer ──
    const openBtns = document.querySelectorAll('[data-open-filters]');
    const closeBtn = document.querySelector('.bomba-drawer__close');
    const drawer   = document.querySelector('.bomba-drawer');
    const overlay  = document.querySelector('.bomba-drawer__overlay');
    const panel    = document.querySelector('.bomba-drawer__panel');
    const applyBtn = document.querySelector('.bomba-drawer__apply');
    let lastOpener = null;
    let closeTimer;

    const openDrawer = (e) => {
      if (!drawer) return;
      clearTimeout(closeTimer);
      lastOpener = e?.currentTarget || null;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-active')));
      const firstFocusable = panel?.querySelector('button, [href], input, select');
      if (firstFocusable) setTimeout(() => firstFocusable.focus(), 380);
    };
    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.style.overflow = '';
      closeTimer = setTimeout(() => drawer.classList.remove('is-open'), 460);
      if (lastOpener) lastOpener.focus();
    };
    const applyDrawer = () => {
      if (!drawer) return;
      const baseUrl = drawer.getAttribute('data-search-url') || '{{ routes.search_url }}';
      const params  = new URLSearchParams();
      // Same reason as above: read the real term from the URL, not from a
      // Liquid tag that {% javascript %} never renders.
      const currentQ = new URLSearchParams(window.location.search).get('q')
        || drawer.querySelector('input[name="q"]')?.value
        || '';
      params.set('q', currentQ);
      params.set('type', 'product');
      drawer.querySelectorAll('[data-filter-input]').forEach((el) => {
        if (el.type === 'checkbox') {
          if (el.checked) params.append(el.name, el.value);
        } else if (el.name === 'sort_by') {
          // Only add sort_by if it has a real value (empty = default = omit)
          if (el.value) params.set(el.name, el.value);
        } else if (el.value !== '' && el.value != null) {
          params.set(el.name, el.value);
        }
      });
      const qs = params.toString();
      window.location.href = qs ? baseUrl + '?' + qs : baseUrl;
    };

    openBtns.forEach((b) => { b.addEventListener('pointerdown', openDrawer); b.addEventListener('click', openDrawer); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', applyDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
